import { render } from "./FAQBlock.vue?vue&type=template&id=19d3d7cb"
import script from "./FAQBlock.vue?vue&type=script&lang=js"
export * from "./FAQBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__